import _ from 'lodash'
import {MutationTree} from 'vuex'
import {CalendarState} from '@/modules/calendar/store/index'
import CalendarEvent from '@/modules/calendar/model/CalendarEvent'
import Vue from 'vue'
import CalendarEventType from '@/modules/calendar/model/CalendarEventType';

export enum MutationTypes {
    SetCalendarEvents = 'SET_CALENDAR_EVENTS',
    SetCurrentCalendarEvent = 'SET_CURRENT_CALENDAR_EVENT',
    UpdateCurrentCalendarEventField = 'UPDATE_CURRENT_CALENDAR_EVENT_FIELD',
    ToggleCreatingCalendarEvent = 'TOGGLE_CREATING_CALENDAR_EVENT',
    SetCalendarEventTypeList = 'SET_CALENDAR_EVENT_TYPE_LIST',
    AddCalendarEvent = 'ADD_CALENDAR_EVENT',
    RemoveCalendarEvent = 'REMOVE_CALENDAR_EVENT',
    ResetCalendarEventNonworking = 'RESET_CALENDAR_EVENT_NONWORKING',
    SetCurrentCalendarEventType = 'SET_CURRENT_CALENDAR_EVENT_TYPE',
    UpdateCurrentCalendarEventTypeField = 'UPDATE_CURRENT_CALENDAR_EVENT_TYPE_FIELD',
    AddCalendarEventType = 'ADD_CALENDAR_EVENT_TYPE',
    DeleteCalendarEventType = 'DELETE_CALENDAR_EVENT_TYPE',
}

const mutations: MutationTree<CalendarState> = {
    /**
     * Registra una lista de eventos de calendario para un determinado mes
     *
     * @param state
     * @param payload
     */
    [MutationTypes.SetCalendarEvents]: (state, events: CalendarEvent[]) => state.calendarEvents = events,

    /**
     * Establece el evento de calendario actualmente seleccionado por el usuario
     *
     * @param state
     * @param event
     */
    [MutationTypes.SetCurrentCalendarEvent]: (state, event: CalendarEvent) => {
        state.currentCalendarEvent = _.cloneDeep(event)
    },

    /**
     * Actualiza uno de los campos del evento de calendario actualmente seleccionado por el usuario
     *
     * @param state
     * @param payload
     */
    [MutationTypes.UpdateCurrentCalendarEventField]: (state, payload: {field: string, value: any}) => {
        _.set(state.currentCalendarEvent, payload.field, payload.value)
    },

    /**
     * Activa o desactiva la lista
     *
     * @param state
     * @param creating
     */
    [MutationTypes.ToggleCreatingCalendarEvent]: (state, creating: boolean) => state.creatingCalendarEvent = creating,

    /**
     * Establece en el estado la lista de tipos de eventos de calendario registrado en
     * la aplicación
     *
     * @param state
     * @param list
     */
    [MutationTypes.SetCalendarEventTypeList]: (state, list: CalendarEventType[]) => state.calendarEventTypes = list,

    /**
     * Registra un evento de calendario en la lista o si ya existe un evento con el mismo id,
     * es reemplazado para la nueva copia
     *
     * @param state
     * @param event
     */
    [MutationTypes.AddCalendarEvent]: (state, event: CalendarEvent) => {
        const index = state.calendarEvents.findIndex(e => e.id === event.id)
        if (index === -1) {
            state.calendarEvents.push(event)

            return
        }

        state.calendarEvents.splice(index, 1, event)
    },

    /**
     * Elimina un evento de calendario
     *
     * @param state
     * @param id
     */
    [MutationTypes.RemoveCalendarEvent]: (state, id: number) => {
        const index = state.calendarEvents.findIndex(e => e.id === id)
        if (index === -1) {
            return
        }

        state.calendarEvents.splice(index, 1)
    },

    /**
     * Reseta el parámetro de "día no laborable" del evento de calendario actualmente en edición.
     * Esto hará que el evento tome el valor del tipo de evento
     * @param state
     */
    [MutationTypes.ResetCalendarEventNonworking]: state => state.currentCalendarEvent.resetNonworking(),

    /**
     * Establece el tipo de evento de calendario actualmente en edición por el usuario
     *
     * @param state
     * @param type
     */
    [MutationTypes.SetCurrentCalendarEventType]: (state, type: CalendarEventType) => {
        state.currentCalendarEventType = _.cloneDeep(type)
    },

    /**
     * Actualiza un campo del tipo de evento en edición por usuario
     *
     * @param state
     * @param payload
     */
    [MutationTypes.UpdateCurrentCalendarEventTypeField]: (state, payload: {field: string, value: any}) => {
        _.set(state.currentCalendarEventType, payload.field, payload.value)
    },

    /**
     * Añade un tipo de evento de calendario a la lista, si ya existe un evento con el mismo
     * id, sustituye el antiguo por la nueva entidad
     *
     * @param state
     */
    [MutationTypes.AddCalendarEventType]: (state, type: CalendarEventType) => {
        const index = state.calendarEventTypes.findIndex(t => t.id === type.id)
        if (index === -1) {
            state.calendarEventTypes.push(type)

            return
        }

        state.calendarEventTypes.splice(index, 1, type)
    },

    /**
     * Añade un tipo de evento de calendario
     *
     * @param state
     * @param type
     */
    [MutationTypes.DeleteCalendarEventType]: (state, id: number) => {
        const index = state.calendarEventTypes.findIndex(et => et.id === id)
        // No existe el tipo de evento de calendario
        if (index === -1) {
            return
        }

        state.calendarEventTypes.splice(index, 1)
    },
}

export default mutations

